export default __webpack_public_path__ + "static/300-sales-teams-2cbc1f7a3cece050800782ad95e86717.png";